/**
 * <MoxoLogo /> — the official Moxo logo (full-colour sphere + MOXO wordmark).
 *
 * Two brand assets ship: the black-wordmark version for light backgrounds and
 * the white-wordmark version for dark. CSS shows the right one per [data-theme]
 * (and always the black-wordmark one in print, since PDFs are on white paper).
 */
import logoColor from '../../assets/moxo-logo.png';
import logoWhite from '../../assets/moxo-logo-white.png';

export default function MoxoLogo({ size = 26 }: { size?: number }) {
  return (
    <span className="moxo-logo">
      <img className="moxo-logo__img moxo-logo__img--light" src={logoColor} alt="Moxo" style={{ height: size }} />
      <img className="moxo-logo__img moxo-logo__img--dark" src={logoWhite} alt="" aria-hidden="true" style={{ height: size }} />
    </span>
  );
}
